module.exports = __webpack_public_path__ + "static/media/bc-mech.3fed05b5.png";